import { defineMessages } from 'react-intl-next';

export default defineMessages({
	retryPrompt: {
		id: 'fabric.editor.ai.config.item.action.retryPrompt',
		defaultMessage: 'Retry',
		description: 'Label for a button in the AI editor modal that allows the user to retry the most recent AI prompt. Shown as an icon button to re-send the last request to the AI service.',
	},
});
